module.exports = __webpack_public_path__ + "img/notice.1a370ce2.png";